import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpEvent
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { AuthService } from '../services/auth.service';
import { TokenStorage } from '../services/token.service';

const TOKEN_HEADER_KEY = 'X-AUTH-TOKEN';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshSubject: Subject<any> = new Subject<any>();

  constructor(
    private token: TokenStorage,
    private router: Router,
    private authService: AuthService,
    private loader: LoaderService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.token.get();
    if (token) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    let pageReloaded = false;

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (!this.router.url.includes('help-document?route=%2Fauth%2Flogin') && !this.router.url.includes('help-document/login')) {
            if (!this.refreshTokenInProgress) {
              this.refreshTokenInProgress = true;
              this.refreshSubject.next(null);

              return this.authService.refreshToken().pipe(
                switchMap((response: any) => {
                  if (response && response.rcode === 200) {
                    this.token.save(response.rObj.token);
                    this.authService.saveRefreshToken(response.rObj.refreshToken);
                    this.authService.b2cAttemptAuth(response.rObj.token);
                    return next.handle(this.addTokenToRequest(req, response.rObj.token));
                  } else {
                    if (!pageReloaded) {
                      pageReloaded = true;
                      localStorage.clear();
                      this.router.navigate(['quotation/get-quote']);
                      setTimeout(() => {
                        this.loader.hide();
                      }, 1000);
                    }
                    return throwError('Token refresh failed');
                  }
                }),
                catchError((refreshError) => {
                  if (!pageReloaded) {
                    pageReloaded = true;
                    localStorage.clear();
                    this.router.navigate(['quotation/get-quote']);
                    setTimeout(() => {
                      this.loader.hide();
                    }, 1000);
                  }
                  return throwError('Token refresh failed');
                }),
                finalize(() => {
                  this.refreshTokenInProgress = false;
                  this.refreshSubject.next(null);
                })
              );
            } else {
              return this.refreshSubject.pipe(
                switchMap(() => {
                  const newToken = this.token.get();
                  return next.handle(this.addTokenToRequest(req, newToken));
                })
              );
            }
          } else {
            return throwError(error);
          }
        } else {
          return throwError(error);
        }
      })
    );
  }

  private addTokenToRequest(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
}
